import { AccountButton } from "@omni/components/components/Navigation/Buttons/AccountButton/accountButton";

import { HeaderButtonComponent } from "@/components/Navigation/Buttons/HeaderButton/headerButton.component";

export const AccountButtonComponent = () => {
    const { headerButtonProps, isLoggedIn } = AccountButton.useContext();

    return (
        <HeaderButtonComponent {...headerButtonProps}>
            {isLoggedIn && <AccountButton.Content />}
        </HeaderButtonComponent>
    );
};
